<section class="user-types">
    <div class="inner">
        <h1>Find the <span>perfect plan</span> for your business.</h1>
        <ul class="user-types">
            <li>
                <header>
                    <h2>Free Trial</h2>
                </header>
                <article>
                    <ul>
                        <li>2 Uses</li>
                    </ul>
                    <p class="info">Not for commercial use</p>
                </article>
                <footer class="button-container">
                    <button (click)="getTrialLink()" *ngIf="!userLoggedIn" class="primary">Register</button>
                    <button (click)="getTrial()" *ngIf="userLoggedIn && userCanTrial" class="primary">Get Free Trial</button>
                    <button *ngIf="userLoggedIn && !userCanTrial" class="primary" disabled="true">Upgrade</button>
                </footer>
            </li>
			      <li>
                <header>
                    <h2>Developer</h2>
                </header>
                <article>
                  <p>FOR INDIVIDUALS</p>
                  <ul>
                    <li>Pay Per Generation</li>
                    <li>No Monthly Fees</li>
                    <li>Never Expires</li>
                    <li>Ideal for Solo Developers & Startups</li>
                    <li>Cloud-Based</li>
                  </ul>
                </article>
                <footer class="button-container">
                    <a role="button" href="https://calendly.com/smartcodeplatform/30min" target="_blank" class="primary">Contact Us</a>
                    <!-- <button (click)="paypalForm()" class="primary">Buy</button> -->
                </footer>
            </li>
            <li>
                <header>
                  <h2>Project</h2>
                </header>
                <article>
				          <p>FOR TEAMS</p>
                  <ul>
                    <li>Pay Per User Seat</li>
                    <li>Flexible Subscription Period</li>
                    <li>Unlimited Generations</li>
                    <li>Perfect for Project-Based Teams</li>
                    <li>Cloud-Based</li>
                  </ul>
                </article>
                <footer class="button-container">
                    <a role="button" href="https://calendly.com/smartcodeplatform/30min" target="_blank" class="primary">Contact Us</a>
                </footer>
            </li>
            <li>
                <header>
                    <h2>Enterprise</h2>
                </header>
                <article>
          				<p>FOR ORGANIZATIONS</p>
                    <ul>
                      <li>Annual Subscription</li>
                      <li>Unlimited Users & Generations</li>
                      <li>Scales With Your Business</li>
                      <li>Best for Enterprise-Wide Integration</li>
                      <li>On-Premises or Cloud-Based</li>
                    </ul>
                </article>
                <footer class="button-container">
                    <a role="button" href="https://calendly.com/smartcodeplatform/30min" target="_blank" class="primary">Contact Us</a>
                </footer>
            </li>
        </ul>
    </div>
</section>
